import * as React from "react";
const SvgPointsV1 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4.667 4.67v6.666a.666.666 0 1 0 1.333 0V4.67a.667.667 0 0 0-1.333 0ZM14.4 6.003a.667.667 0 0 0-.52.787 6.001 6.001 0 1 1-4.667-4.667A.68.68 0 0 0 9.48.79 7.156 7.156 0 0 0 8 .67a7.333 7.333 0 1 0 7.187 5.867.666.666 0 0 0-.787-.534Zm-3.733 0v4a.666.666 0 0 1-.667.667h-.667a.666.666 0 0 1-.666-.667v-4c0-.368.298-.666.666-.666H10c.369 0 .667.298.667.666Zm-3.334 0v4a2 2 0 0 0 2 2H10a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.667a2 2 0 0 0-2 2ZM12 3.337h.667v.666a.666.666 0 1 0 1.333 0v-.666h.667a.666.666 0 1 0 0-1.334H14v-.666a.666.666 0 1 0-1.333 0v.666H12a.666.666 0 1 0 0 1.334Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPointsV1;
